import { isDemo } from './config'
import { api as demoApi } from './api.demo'
import { api as supabaseApi } from './api.supabase'

// Begge implementasjonene har nøyaktig samme grensesnitt, slik at ingen
// komponent trenger å vite hvilken som er i bruk.
export const api = isDemo ? demoApi : supabaseApi
export { isDemo }
export { DEMO_FAMILY_CODE } from './api.demo'
